import {ref, computed, watch} from "@vue/composition-api";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import router from "@/router";
import {debounce} from "lodash";
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  store.dispatch("maintenance/getAll");
  store.dispatch("country/getAll");
  store.dispatch("tenant/getAll");
  const refListTable = ref(null);
  const toast = useToast();
  const countryOptions = computed(() => store.getters["country/getSelectedItems"]);
  const countryFilter = ref(null);
  const tenantOptions = computed(() => store.getters["tenant/getSelectedItems"]);
  const tenantFilter = ref(null);

  if (router.currentRoute.params.name)
    countryFilter.value = parseInt(router.currentRoute.name);

  const tableColumns = [
    {label: "actions.name", key: "actions"},
    {label: "name", key: "name", sortable: false},
    {label: "maintenance.address", key: "address", sortable: false},
    {label: "maintenance.manager_name", key: "manager_name", sortable: false},
    {label: "maintenance.manager_plate", key: "manager_plate", sortable: false},
    {label: "maintenance.country_name", key: "country.name", sortable: false},
    {label: "tenants", key: "tenants", sortable: false},
    {
      label: 'date.created_at',
      key: 'created_at',
      sortable: true,
      formatter: 'formatDateAssigned'
    },
    {
      label: 'date.updated_at',
      key: 'updated_at',
      sortable: true,
      formatter: 'formatDateAssigned'
    },
  ];

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {

    store
      .dispatch("maintenance/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        id_country: countryFilter.value,
        id_tenant: tenantFilter.value,
      })
      .then((response) => {
        console.log(response.data, "datos");
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch(
    [countryFilter, currentPage, perPage, tenantFilter],
    () => {
      refetchData();
    }
  );

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      id_country: countryFilter.value,
      id_tenant: tenantFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    countryFilter.value = null;
    tenantFilter.value = null;
    buildFilters();
  }
  
  return {
    tenantOptions,
    tenantFilter,
    refListTable,
    countryOptions,
    countryFilter,
    tableColumns,
    perPage,
    totalList,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    fetchList,
    formatDateAssigned,
    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount,
  };
}
